import {endOfMonth, startOfMonth} from 'date-fns'

type Period = {
  startsAt: string,
  endsAt: string
}

export function getStartAndEndOfMonth(isoDate: string): Period {
  const date = new Date(isoDate)

  return {
    startsAt: startOfMonth(date).toISOString(),
    endsAt: endOfMonth(date).toISOString()
  }
}
